<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col
              :md="8"
              :sm="24"
            >
              <a-form-item
                label="配置名称"
                prop="configName"
              >
                <a-input
                  v-model="queryParam.configName"
                  placeholder="请输入配置名称"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <!-- <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="配置链接-序列号" prop="configSn">
                  <a-input v-model="queryParam.configSn" placeholder="请输入配置链接-序列号" allow-clear/>
                </a-form-item>
              </a-col>
            </template> -->
            <a-col
              :md="!advanced && 8 || 24"
              :sm="24"
            >
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
              >
                <a-button
                  type="primary"
                  @click="handleQuery"
                ><a-icon type="search" />查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.createForm.handleAdd()"
          v-hasPermi="['tram:config:add']"
        >
          <a-icon type="plus" />新增
        </a-button>
        <!-- <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['tram:config:edit']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button
          type="danger"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['tram:config:remove']"
        >
          <a-icon type="delete" />删除
        </a-button>
        <a-button
          type="primary"
          @click="$refs.importExcel.importExcelHandleOpen()"
        >
          <a-icon type="import" />导入
        </a-button>
        <a-button
          type="primary"
          @click="handleExport"
        >
          <a-icon type="download" />导出
        </a-button> -->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span
          slot="createTime"
          slot-scope="text, record"
        >
          {{ parseTime(record.createTime) }}
        </span>
        <!-- <span
          slot="isSystem"
          slot-scope="text, record"
        >
          <a-tag v-if="record.isSystem=1">
            是
          </a-tag>

          <a-tag v-if="record.isSystem=0">
            否
          </a-tag>
        </span> -->
        <span
          slot="operation"
          slot-scope="text, record"
        >
          <!-- <a-divider
            type="vertical"
            v-hasPermi="['tram:config:edit']"
          />
          <a
            @click="$refs.createForm.handleUpdate(record, undefined)"
            v-hasPermi="['tram:config:edit']"
          >
            <a-icon type="edit" />修改
          </a> -->
          <!-- <a-divider
            type="vertical"
            v-hasPermi="['tram:config:remove']"
          /> -->
          <a
            @click="handleDelete(record)"
            v-hasPermi="['tram:config:remove']"
          >
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <!-- 上传文件 -->
      <import-excel
        ref="importExcel"
        @ok="getList"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageConfig, delConfig } from '@/api/tram/config'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import ImportExcel from './modules/ImportExcel'
export default {
  name: 'Config1',
  components: {
    CreateForm, ImportExcel
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        configName: null,
        configValue: null,
        configSn: null,
        pageNum: 1,
        pageSize: 10,
        configType: 0
      },
      columns: [
        {
          title: '用户名',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          ellipsis: true,
          align: 'center'
        },

        {
          title: '配置名称',
          dataIndex: 'configName',
          ellipsis: true,
          align: 'center'
        },

        {
          title: '配置链接-序列号',
          dataIndex: 'configSn',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '是否系统配置',
        //   dataIndex: 'isSystem',
        //   scopedSlots: { customRender: 'isSystem' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询配置信息列表 */
    getList () {
      this.loading = true
      pageConfig(this.queryParam).then(response => {
        console.log(response.data.records, 'response.data.records')
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        configName: undefined,
        configValue: undefined,
        configSn: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delConfig(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('tram/tram-config/export', {
            ...that.queryParam
          }, `配置信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () { }
      })
    }
  }
}
</script>
